export default {
  title: 'Confirm your action',
  sendInviteTextStart: 'Are you sure you want to send an invitation email to ',
  moveToInvitedTextStart: 'Are you sure you want to move ',
  sendInviteTextEnd: '? Please make sure all fields have been entered correctly.',
  moveToInvitedTextEnd:
    ' to the Invited status? Please make sure all fields have been entered correctly.',
  resendInviteTextStart: 'Are you sure you want to resend an invitation email to ',
  resendInviteTextEnd: '? Please make sure all fields have been entered correctly.',
  sendEmailToUserManagerStart: 'Are you sure you want to notify ',
  sendEmailToUserManagerEnd:
    ' has been assigned to them for the onboarding process? Please make sure all fields have been entered correctly.',
  buttonCancel: 'Cancel',
  sendInviteButtonSubmit: 'Invite User',
  resendInviteButtonSubmit: 'Resend',
  notifyButton: 'Notify',
  moveToInvitedButton: 'Move to Invited',
  successInvite: 'Invitation email has been sent',
  successInviteResend: 'Invitation email has been resent',
  successEmailToUserManager: 'Email has been sent to the User Manager',
  successMoveToInvited: 'The user has been moved to the Invited status',
};
